import type { Block, FigureData } from "../../../../models/ManualAuthoring";
import "./figure.css";

export default function FigureView({
  block,
  figureNumber,
}: {
  block: Block;
  figureNumber?: number;
}) {
  const data = block.data as FigureData;
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";

  const resolveSrc = (folderPath: string) => {
    if (!folderPath) return "";
    if (/^https?:\/\//i.test(folderPath)) return folderPath;
    if (folderPath.startsWith("/media/")) return `${baseUrl}${folderPath}`;
    if (folderPath.startsWith("media/")) return `${baseUrl}/${folderPath}`;
    return `${baseUrl}/media/${folderPath}`;
  };

  return (
    <div className="pdf-block pdf-figure">
      {data.folderPath && (
        <img
          src={resolveSrc(data.folderPath)}
          alt={data.caption ?? "Figure"}
          className="pdf-figure__image"
        />
      )}

      {(data.caption || figureNumber) && (
        <div className="pdf-figure__caption">
          <span className="pdf-figure__caption-label">
            Figure {figureNumber ?? "—"}.
          </span>{" "}
          {data.caption ?? ""}
        </div>
      )}
    </div>
  );
}
